import { render, staticRenderFns } from "./triggers.vue?vue&type=template&id=51e5a057&scoped=true"
import script from "./triggers.vue?vue&type=script&lang=js"
export * from "./triggers.vue?vue&type=script&lang=js"
import style0 from "./triggers.vue?vue&type=style&index=0&id=51e5a057&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e5a057",
  null
  
)

export default component.exports